/**
 * @file This file contains the function that help Field component provide contextual data in a type-checker-friendly way to the children within it without explicitly passing them as props.
 */
import { func } from '@codegrade/utils';
/**
 * The key used to provide and inject the field data.
 *
 * Symbol is said to be usable according to the docs of Vue 2, but in practice it is somehow not usable. Thus we are using a string here.
 */
export const FieldContextKey = 'cg-form-field-context';
/**
 * Method to prepare a object to make a Vue component retrieves the provided Field context data.
 *
 * @returns An object to be added to the "inject" option when creating control components.
 */
export function injectFieldContext() {
    return {
        [FieldContextKey]: {
            /** @returns Default values if the form context data cannot be found. */
            default() {
                return () => ({
                    inputId: undefined,
                    descriptionId: undefined,
                    register: () => undefined,
                    deregister: func.noop,
                });
            },
        },
    };
}
/**
 * Method to make the provided field context data available in a component as a computed property.
 *
 * @returns The data to be spread in the "computed" option when creating control components.
 */
export function useFieldContextValue() {
    return {
        /** @returns The field context data made available under the given computedPropName. */
        fieldContext() {
            return this[FieldContextKey]?.();
        },
    };
}
